import {API} from "aws-amplify";

const clients = require('./clients');
import {constants} from "@/common/Constants";

export default {
    createDescription(formData) {
        return `## Task ID: \n` +
            `00-${this.generateTaskID()} \n \n` +

            `## Client: \n` +
            `${formData.organization.name} \n \n` +

            `## Point of Contact: \n` +
            `${formData.fullName} (${formData.email}) \n \n` +

            "## Domain: \n" +
            `${formData.website.domain} \n \n` +

            `## Request: \n` +
            `${this.displayPages(this.convertToJson(formData.pages))}` +

            `## Files: \n` +
            `${this.displayFiles(this.convertToJson(formData.files))}`
    },

    emailMessage(input) {
      return `
        <body>
          <link
            rel="stylesheet"
            href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css"
            integrity="sha384-JcKb8q3iqJ61gNV9KGb8thSsNjpSL0n8PARn9HuZOnIxN0hoP+VmmDGMN5t9UJ0Z"
            crossorigin="anonymous"
          />
          <div class="container" style="margin-top: 25px;">
            <div class="row" style="margin-bottom: 20px;">
              <div class="col">
                <img
                  style="
                    display: block;
                    max-width: 250px !important;
                    width: 40%;
                    height: auto !important;
                    border: 0;
                  "
                  width="270"
                  alt=""
                  data-proportionally-constrained="true"
                  data-responsive="true"
                  src="http://cdn.mcauto-images-production.sendgrid.net/3b0ca099b12b44fa/e969fa9b-27b1-4043-bff1-f1f98ff3f922/678x148.png"
                />
              </div>
            </div>
            <div class="row" margin-bottom: 20px;">
              <div class="col">
                <h3>Request Confirmation</h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p>Hi ${input.firstName},</p>
                <p>
                  Thank you for using the Client Portal! We have received your request
                  and will get working on it right away. To track the status of your
                  request, log back into the portal and click 'Dashboard.'
                </p>
                <p style="font-weight: bold; font-size: 16px;">
                  Your Ticket ID = ${input.ticketID}
                </p>
                <p>Below is a copy of the information we received:</p>
                <ul>
                  <li><u>Title</u>: ${input.title}</li>
                  <li><u>Urgent</u>: ${input.urgent}</li>
                  <li><u>Due Date</u>: ${input.dueDate}</li>
                  <li><u>Domain</u>: ${input.domain}</li>
                  <li><u>Pages</u>:</li>
                  <ul>
                    ${input.pages}
                  </ul>
                  <li><u>Files</u>:</li>
                  <ul>
                    ${input.files}
                  </ul>
                </ul>
                <p>
                  If you have any questions, please contact your TEAMTRI lead. Thanks so
                  much for your partnership!
                </p>
                <p>- TEAMTRI Tech Team</p>
              </div>
            </div>
          </div>
        </body>
`
    },

    generateTaskID() {
        return Math.floor(Math.random() * 100000).toString();
    },

    displayTitle(formData) {
        return `${formData.organization.shortName}: ${formData.title}`
    },

    displayPages(pages) {
        let formattedPages = "";
        for(let i = 1 ; i <= pages.length ; i++) {
            let page = pages[i - 1];
            formattedPages += `**Page #${i}** \n \n` +
                `* URL: ${page.url} \n` +
                `* Description: ${page.description} \n \n`
        }
        return formattedPages
    },

    translateUrgent(urgent) {
        if (urgent) {
            return "Yes"
        }
        return "No"
    },

    translatePages(pages) {
        let pagesHtml = ""
        for(let i = 0 ; i < pages.length ; i++) {
            const page = pages[i];
            pagesHtml = pagesHtml +
                "<li>Page #" + (i + 1) + "</li>" +
                "<ul>" +
                    "<li>URL: " + page.url + "</li>" +
                    "<li>Description: " + page.description + "</li>" +
                "</ul>"
        }
        return pagesHtml;
    },

    translateFiles(files) {
        if(files.length === 0) {
            return "<li>None</li>"
        }

        let filesHtml = "";
        for(let i = 0 ; i < files.length ; i++) {
            const file = files[i];
            filesHtml = filesHtml +
                "<li>" + file.name + "</li>"
        }
        return filesHtml;
    },

    displayFiles(files) {
        if(files.length === 0) {
            return "-- None --"
        }

        let formattedFiles = "";
        let baseURL = "https://teamtri-clientportal223031-prod.s3.us-east-2.amazonaws.com/public/"

        for(let i = 1 ; i <= files.length ; i++) {
            let file = files[i - 1];
            formattedFiles += `* [${file.name}](${encodeURI(baseURL + file.s3Key)})\n`
        }

        return formattedFiles
    },

    findTicketID(description) {
        const startOfID = description.search(":") + 3;
        const slicedDescription = description.substring(startOfID);
        const endOfID = slicedDescription.search("#") - 4;
        return description.substring(startOfID, startOfID + endOfID);
    },

    convertToJson(input) {
        return JSON.parse(JSON.stringify(input))
    },

    ccList(org) {
        const clientLeads = org.clientLeads;

        if (clientLeads.length === 0) {
            clientLeads[0] = constants.defaultClientLead.username
        }

        for (let i = 0 ; i < clientLeads.length ; i++) {
            clientLeads[i] = "@" + clientLeads[i];
        }

        return clientLeads.toString();
    }

}